// src/lib/BaseMentionPlugin.ts
import {
  createSlatePlugin,
  createTSlatePlugin
} from "@udecode/plate";
import {
  withTriggerCombobox
} from "@udecode/plate-combobox";
var BaseMentionInputPlugin = createSlatePlugin({
  key: "mention_input",
  node: { isElement: true, isInline: true, isVoid: true }
});
var BaseMentionPlugin = createTSlatePlugin({
  key: "mention",
  node: { isElement: true, isInline: true, isMarkableVoid: true, isVoid: true },
  options: {
    trigger: "@",
    triggerPreviousCharPattern: /^\s?$/,
    createComboboxInput: (trigger) => ({
      children: [{ text: "" }],
      trigger,
      type: BaseMentionInputPlugin.key
    })
  },
  plugins: [BaseMentionInputPlugin]
}).extendEditorTransforms(({ editor, type }) => ({
  insert: {
    mention: ({ key, value }) => {
      editor.tf.insertNodes({
        key,
        children: [{ text: "" }],
        type,
        value
      });
    }
  }
})).overrideEditor(withTriggerCombobox);

// src/lib/getMentionOnSelectItem.ts
import { getEditorPlugin } from "@udecode/plate";
var getMentionOnSelectItem = ({
  key = BaseMentionPlugin.key
} = {}) => (editor, item, search = "") => {
  const { getOptions, tf } = getEditorPlugin(editor, {
    key
  });
  const { insertSpaceAfterMention } = getOptions();
  tf.insert.mention({ key: item.key, search, value: item.text });
  editor.tf.move({ unit: "offset" });
  const pathAbove = editor.api.block()?.[1];
  const isBlockEnd = editor.selection && pathAbove && editor.api.isEnd(editor.selection.anchor, pathAbove);
  if (isBlockEnd && insertSpaceAfterMention) {
    editor.tf.insertText(" ");
  }
};
export {
  BaseMentionInputPlugin,
  BaseMentionPlugin,
  getMentionOnSelectItem
};
//# sourceMappingURL=index.mjs.map